var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"tag",class:_vm.computedClass,on:{"click":function($event){return _vm.toggleTag(_vm.tag)}}},[_vm._v(" #"+_vm._s(_vm.tag.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }